import { useNavigate, useSearchParams } from "react-router-dom";
import RecipeZone from "../games/MathZoo/components/RecipeZone";

/**
 * Recipe Zone standalone page
 * Displays the Recipe Zone component directly
 * Supports language parameter in URL: /recipes?lang=en or /recipes?lang=zh
 */
const RecipeZonePage = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const lang = searchParams.get("lang") || "zh";

  const handleBack = () => {
    navigate("/");
  };

  const handleLanguageChange = (newLang) => {
    setSearchParams({ lang: newLang });
  };

  return (
    <RecipeZone
      onBack={handleBack}
      initialLanguage={lang}
      onLanguageChange={handleLanguageChange}
    />
  );
};

export default RecipeZonePage;
